// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2ye0F","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1TPBj"};